import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#006400",
    },
    custom: {
      main: "#ff0000",
    },
  },
});
